const RECITE_ME_BAR_HEIGHT = 60;

export function getReciteMeBarHeight() {
	const reciteMeOpen =
		typeof document !== 'undefined' &&
		!!document?.getElementById('recite-header');

	const height = reciteMeOpen ? RECITE_ME_BAR_HEIGHT : 0;

	return height;
}
